














































































































import { Component, Inject, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";
import {
  IOrdersProvider,
  IOrdersProviderMethods
} from "@/models/providers/orders";

@Component({
  components: {
    "relative-invoice-status": () =>
      import("@/components/app/global/invoices/relativeInvoiceStatus.vue"),
    "order-items-summary": () =>
      import("@/components/app/global/orders/orderItemsSummary.vue")
  }
})
export default class RecentOrdersList extends Mixins(Context) {
  // Inject

  @Inject({ from: "ordersProvider" })
  public ordersProvider!: () => IOrdersProvider;

  @Inject({ from: "ordersProviderMethods" })
  public $ordersMethods!: IOrdersProviderMethods;

  // Computed

  public get $ordersData() {
    return this.ordersProvider();
  }

  public get orders() {
    return this.$ordersData.orders;
  }

  public get guardFunctionalities() {
    return this.$ordersData.guardFunctionalities;
  }

  public get isLoading() {
    return this.$ordersData.isLoading;
  }

  public get isReloading() {
    return this.$ordersData.isReloading;
  }

  public get clientId() {
    return this.$ordersData.clientId;
  }
}
